import { useEffect, useRef } from 'react'

import { IoWarning } from 'react-icons/io5'

import { Outlet, useLoaderData, useLocation } from 'react-router-dom'

import FrontHeader   from '../Navigation/frontend/FrontHeader'
import FrontFooter   from '../Navigation/frontend/FrontFooter'

import request from '../Functions/ajax/request'

import SuspendedLayout from '../../SuspendedLayout'

import AccountStore from '../../Stores/Account'
import ServerStore  from '../../Stores/ServerStore'
import RolesStore   from '../../Stores/Roles'

import refreshServerStore from '../../StoresFunctions/refreshServerStore'
import setAccountStore    from '../../StoresFunctions/setAccountStore'
import setRolesStore      from '../../StoresFunctions/setRolesStore'

export default function FrontLayout (props)
{
	const { page } = useLoaderData();

	const roles_status = RolesStore.useState(s => s.status);

	const is__catalog_suspended = ServerStore.useState(s => s.status === 'suspended');

	const account_state = AccountStore.useState(s => s.status);

	const location = useLocation();

	const _refs = useRef();

	useEffect(() =>
	{
		if (account_state === 'set') return () => void 0;

		(async function fetchAccount ()
		{
			try
			{
				var { user } = await request('/auth/get-my-account')
				.config({ })
				.post();
			}
			catch (update)
			{
				return;
			}

			if (user)
			{
				setAccountStore(
				{
					user_id: user._id, code_client: user.code_client
				});
			}
		})();
	},
	[account_state]);

	useEffect(function ()
	{
		if (!location.pathname) return;

		_refs.current ||= { };

		if (_refs.current.init !== true)
		{
			_refs.current.init = true;

			return;
		}

		refreshServerStore();
	},
	[location.pathname]);

	useEffect(() =>
	{
		if (roles_status !== 'pending') return;

		const controller = new AbortController();

		(async function fetchRoles ()
		{
			try
			{
				var { roles, user_id } = await request('/auth/get-roles')
				.config({ controller })
				.post();
			}
			catch (update)
			{
				return;
			}

			setRolesStore({ roles, user_id });
		})();

		return () => controller?.abort?.();
	},
	[roles_status]);

	let page_class = 'front-page';

	if (props.className)
	{
		page_class += ' ' + props.className;
	}

	return (
		<SuspendedLayout resolve={ page }>

			<div className={ page_class }>
				{
					is__catalog_suspended ?
					(
						<div className="front-maintenance-msg">
							<IoWarning className="front-maintenance-msg__icon" />
							Le catalogue et les commandes sont temporairement désactivés.
						</div>
					)
					: undefined
				}
				<FrontHeader />
				<Outlet />
				<FrontFooter />
			</div>

		</SuspendedLayout>
	);
}